import './Banner.scss';

type Props = {
	className?: string;
	hasLoader?: boolean;
	children?: React.ReactNode;
};

const Banner = ({ className, hasLoader = false, children }: Props) => {
	return (
		<div className={className ? `banner ${className}` : 'banner'}>
			{hasLoader ? (
				<div
					aria-busy="true"
					className="loader"
					role="alert"
				></div>
			) : null}
			<div className="banner--content">{children}</div>
		</div>
	);
};

export { Banner };
